import Logo from '../components/Logo'

export default function Privacy() {
  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <div style={{ background: '#185FA5', padding: '24px 20px', textAlign: 'center' }}>
        <Logo variant="light" width="180px" maxWidth="180px" style={{ margin: '0 auto' }} />
      </div>
      <div style={{ maxWidth: '720px', margin: '0 auto', padding: '32px 20px 60px' }}>
        <button type="button" onClick={() => { window.location.href = '/' }} style={backLink}>← Back to home</button>

        <h1 style={{ fontSize: '24px', fontWeight: '600', margin: '20px 0 4px' }}>Privacy statement</h1>
        <p style={{ fontSize: '13px', color: '#888', marginBottom: '28px' }}>Last updated: 19 June 2026</p>

        <Section title="Who we are">
          <p>
            GAA Match Tracker is a match-tracking tool for GAA clubs, built and operated by Stuart McPartlan, based in Ireland.
            If you have any questions about this privacy statement or how your data is handled, you can contact us at any time
            via our <a href="/contact" style={linkStyle}>contact page</a>.
          </p>
        </Section>

        <Section title="What information we collect">
          <p>When you create an account, we collect:</p>
          <ul style={listStyle}>
            <li>Your full name</li>
            <li>Your email address</li>
            <li>Your password (stored securely and encrypted — we never see or store it in plain text)</li>
            <li>Your club name and county</li>
            <li>The squad(s) and age group(s) you're associated with</li>
            <li>Your role within the club (e.g. coach, squad admin, club admin)</li>
          </ul>
          <p>If you contact us through our contact form, we additionally collect:</p>
          <ul style={listStyle}>
            <li>Your name and email address</li>
            <li>Your club, if you choose to provide it (this field is optional)</li>
            <li>The content of your message</li>
          </ul>
          <p>
            We do not collect or store any information about individual players (such as children) beyond what coaches choose
            to enter for match-tracking purposes — for example, a player's name and jersey number within a squad they manage.
            We do not knowingly collect any sensitive personal data, and we don't use tracking or advertising cookies.
          </p>
        </Section>

        <Section title="How we use your information">
          <p>We use the information you provide to:</p>
          <ul style={listStyle}>
            <li>Create and manage your account</li>
            <li>Let you and your club track matches, fixtures, and results</li>
            <li>Send you account-related emails, such as invites to join a squad or password reset links</li>
            <li>Respond to questions or issues you raise with us via the contact form</li>
          </ul>
          <p>We do not sell, rent, or share your personal data with any third party for marketing or advertising purposes.</p>
        </Section>

        <Section title="Who else sees your data">
          <p>
            We use a small number of trusted service providers to run GAA Match Tracker. These providers process data on our
            behalf and are not permitted to use it for their own purposes:
          </p>
          <ul style={listStyle}>
            <li><strong>Supabase</strong> — provides our database, authentication, and hosting infrastructure</li>
            <li><strong>Resend</strong> — sends transactional emails on our behalf, such as invites and password resets</li>
          </ul>
          <p>
            Some squad and match information you or your club choose to make public (such as live scores and fixture results)
            is visible to anyone with the relevant public link, without needing to log in. This is intentional — it's designed
            so supporters can follow matches — and only includes match and squad data, never personal contact details like
            email addresses.
          </p>
        </Section>

        <Section title="How long we keep your data">
          <p>
            We retain your account information for as long as your account remains active. If you'd like your account and
            associated personal data deleted, contact us and we'll action this within a reasonable timeframe, except where
            we're required to retain certain records for legal reasons.
          </p>
        </Section>

        <Section title="Your rights">
          <p>Under GDPR, you have the right to:</p>
          <ul style={listStyle}>
            <li>Access the personal data we hold about you</li>
            <li>Request that inaccurate data be corrected</li>
            <li>Request that your data be deleted</li>
            <li>Object to or restrict certain processing of your data</li>
            <li>Request a copy of your data in a portable format</li>
          </ul>
          <p>
            To exercise any of these rights, please get in touch via our <a href="/contact" style={linkStyle}>contact page</a>.
            If you're unhappy with how we've handled your data, you also have the right to lodge a complaint with the{' '}
            <a href="https://www.dataprotection.ie" target="_blank" rel="noopener noreferrer" style={linkStyle}>
              Irish Data Protection Commission
            </a>.
          </p>
        </Section>

        <Section title="Cookies">
          <p>
            We don't use tracking, analytics, or advertising cookies. We use a small amount of strictly necessary local
            browser storage to keep you signed in — this is essential for the site to function and doesn't require consent
            under ePrivacy rules.
          </p>
        </Section>

        <Section title="Changes to this statement">
          <p>
            We may update this privacy statement from time to time as the service evolves. We'll update the "last updated"
            date at the top of this page whenever we make changes.
          </p>
        </Section>
      </div>
    </div>
  )
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: '28px' }}>
      <h2 style={{ fontSize: '17px', fontWeight: '600', marginBottom: '10px', color: '#185FA5' }}>{title}</h2>
      <div style={{ fontSize: '14px', color: '#333', lineHeight: '1.7' }}>{children}</div>
    </div>
  )
}

const backLink = { background: 'none', border: 'none', color: '#185FA5', fontSize: '13px', cursor: 'pointer', textDecoration: 'underline', padding: 0 }
const linkStyle = { color: '#185FA5' }
const listStyle = { margin: '8px 0', paddingLeft: '20px', lineHeight: '1.8' }